import { render } from "./cfSelectv2.vue?vue&type=template&id=7fa01070&ts=true"
import script from "./cfSelectv2.vue?vue&type=script&lang=ts"
export * from "./cfSelectv2.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__